import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=e5a3968a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5a3968a')) {
      api.createRecord('e5a3968a', component.options)
    } else {
      api.reload('e5a3968a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=e5a3968a&", function () {
      api.rerender('e5a3968a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TmjCJ8aAlx5B/JS/comp/FavElement.vue"
export default component.exports